/**
 * Shipments Domain Constants
 */

// ============================================
// Pagination
// ============================================

export const DEFAULT_PAGE_SIZE = 10
export const MAX_PAGE_SIZE = 1000

// ============================================
// Default Values
// ============================================

export const DEFAULT_LOCATION_NAME = '-'

// ============================================
// Status Mappings (API → Domain)
// ============================================

export const API_SHIPMENT_STATUS_TO_DOMAIN = {
  pending: 'scheduled',
  loading: 'loading',
  in_transit: 'in-transit',
  arrived: 'delivered',
  completed: 'delivered',
  cancelled: 'cancelled',
} as const

// ============================================
// Status Mappings (Domain → API)
// ============================================

export const DOMAIN_SHIPMENT_STATUS_TO_API = {
  scheduled: 'pending',
  loading: 'loading',
  'in-transit': 'in_transit',
  delivered: 'completed',
  cancelled: 'cancelled',
} as const

// ============================================
// Shipment Number Prefix
// ============================================

export const SHIPMENT_NUMBER_PREFIX = 'SHP'
